import { useQuery } from "@common/utils/use-query";
import { AddOnsStore } from "./types";

export const addonsStore: AddOnsStore = {
  useGetAddOns({ enabled } = { enabled: true }) {
    return useQuery(
      { url: "/addons" },
      {
        enabled,
        refetchInterval: 1000 * 60 * 60 * 12, // reload every 12 hours
        refetchIntervalInBackground: true,
        refetchOnWindowFocus: true,
      },
    );
  },
};
